import '@/app/app.css';
import './product.css';

import '@/app/app';
import '@/layouts/main/main';

import { ModalGallery } from '@/features/modal/modal-gallery/modal-gallery';
import { DiscountTimer } from '@/shared/discount-timer/discount-timer';
import { ProductGallery } from './sections/product-gallery/product-gallery';
import { ProductInfo } from './sections/product-info/product-info';
import { SwiperCarousel } from '@/shared/swiper/swiper-carousel/swiper-carousel';

window.addEventListener('DOMContentLoaded', () => {
	new ModalGallery();
	new ProductGallery(document.querySelector('.js-product-gallery'));
	new ProductInfo(document.querySelector('.js-product-info'));
	initDiscountTimer();

	document.querySelectorAll('.js-swiper-carousel').forEach((element) => {
		new SwiperCarousel(element);
	});

	const likeButton = document.querySelector('.js-product-like--demo');
	likeButton && likeButton.addEventListener('click', showProductFavouriteNotify);

	const cartButton = document.querySelector('.js-product-cart--demo');
	cartButton && cartButton.addEventListener('click', showProductCartNotify);
});

function initDiscountTimer() {
	const discountTimer = document.querySelector('.js-product-discount-timer');
	if (!discountTimer) return;

	new DiscountTimer(discountTimer);
	discountTimer.addEventListener('timerComplete', handleDiscountTimerEnd);
}

function handleDiscountTimerEnd({ currentTarget }) {
	currentTarget.remove();
	document.querySelector('.product-info__discount-label')?.remove();
}

function showProductFavouriteNotify({ target }) {
	if (!target.closest(':has(.product-like--active)')) return;

	window.app.productNotify({
		type: 'favourite',
		title: 'Снуд платочка из меринос-кашемира',
		price: '1 490 р.',
		size: '6-9 мес.',
		color: 'Бежевый',
		image: '../images/content/product-notify-01.jpg',
		link: '#!',
		linkText: 'Перейти в избранное',
		delay: 5000,
	});
}

function showProductCartNotify() {
	window.app.productNotify({
		type: 'cart',
		title: 'Снуд платочка из меринос-кашемира',
		price: '1 490 р.',
		size: '6-9 мес.',
		color: 'Бежевый',
		image: '../images/content/product-notify-01.jpg',
		link: '#!',
		linkText: 'Перейти в корзину',
		delay: 5000,
	});
}
